import React, { useState ,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import logo from '../../../logo.png';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LoadingButton from '@mui/lab/LoadingButton';
import { getUserByEmailAddress, userLogin ,verifyToken} from '../../../clientServices/UserService';
import emailjs from 'emailjs-com';
import { getRoleById } from '../../../clientServices/RoleService';

const Login = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    emailjs.init('OGeC5v16OEXHrsSlr');

    const [user, setUser] = useState({
        Password: '',
        Email: '',
    });

    const [isForgotPassword, setIsForgotPassword] = useState(false);

    const handleChange = (event) => {
        setUser({
            ...user,
            [event.target.name]: event.target.value,
        });
    };

    const handleUserLogin = async (e) => {
        try {
            const userData = await userLogin(user);
            console.log(userData, "client>>>>>>>>")
            if (userData != null) {
                // נשמור את ה-token ב-localStorage
                localStorage.setItem('token', userData.data.token);

                // שמירה של פרטי המשתמש
                localStorage.setItem('email', userData.data.user.Email);
                localStorage.setItem('name', userData.data.user.Name);

                var role = await getRoleById(userData.data.user.RoleID);
                console.log(role, "roleeeeee")
                localStorage.setItem('role', role.data.Role);
                localStorage.setItem('roleId', userData.data.user.RoleID);


                if (userData.data.user.RoleID === 1) {
                    navigate('/admin', { state: 1 });
                } else if (userData.data.user.RoleID === 2) {
                    navigate('/pagesNavigate', { state: 2 });
                } else {
                    navigate('/pagesNavigate', { state: 3 });
                }
            }
        } catch (error) {
            console.error('בעיה בכניסת משתמש', 3, error);
            alert("שגיאה");
        }
    };

    // פונקציה לבדוק אם יש token ב-localStorage ולהיכנס אוטומטית
    const checkAuth = async () => {
        const token = localStorage.getItem('token');
        console.log("check token" ,token)
        if (token) {
            // אם יש token, שלח אותו לשרת כדי לבדוק אם הוא תקף
            const userData = await verifyToken(token);
            console.log("userData ",userData)
            if (userData) {
                // המשך לניווט למקום המתאים
                const localRole = localStorage.getItem('roleId')
                console.log(localRole, "localRole")
                if (localRole === '1') {
                    navigate('/admin', { state: 1 });
                    console.log("admin")
                } else if (localRole === '2') {
                    navigate('/pagesNavigate', { state: 2 });
                    console.log("admin2")

                } else {
                    navigate('/pagesNavigate', { state: 3 });
                    console.log("admin3")

                }
            } else {
                // אם ה-token לא תקף, נבצע יציאה
                localStorage.removeItem('token');
            }
        }
    };




    const generateRandomPassword = () => {
        const characters = '0123456789';
        let password = '';
        for (let i = 0; i < 5; i++) {
            password += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return password;
    };

    const handleForgotPassword = async (e) => {

        if (!user.Email) {
            alert("נא הכנס כתובת מייל");
        } else {
            try {
                const isExist = await getUserByEmailAddress(user.Email);
                console.log(isExist, "isExist")
                if (!isExist || !isExist.data) {
                    alert("מייל זה לא קיים במערכת");
                } else {
                    localStorage.setItem('email', isExist.data.Email);
                    localStorage.setItem('name', isExist.data.Name);

                    var role = await getRoleById(isExist.data.RoleID);
                    localStorage.setItem('role', role.data.Role);
                    localStorage.setItem('roleId',isExist.data.RoleID);

                    const generatedPassword = generateRandomPassword();
                    const templateParams = {
                        to_name: isExist.Name,
                        to_email: user.Email,
                        message: generatedPassword,
                    };

                    emailjs.send(
                        'service_b5emsma', // service ID
                        'template_5f0jjve', // template ID
                        templateParams
                    )
                        .then((response) => {
                            console.log('SUCCESS!', response.status, response.text);
                            navigate('/checkPassword', { state: generatedPassword });
                        })
                        .catch((error) => {
                            console.error('FAILED...', error);
                        });
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    alert("מייל זה לא קיים במערכת");
                } else {
                    console.error('Error fetching user:', error);
                    alert("An error occurred. Please try again later.");
                }
            }
        }
    };

    // קרא לפונקציה בעת טעינת הדף
    useEffect(() => {
        checkAuth();
    }, []);
    return (
        <>
            <div className='loginPageCont'>
                <div className="login-container">
                    <img className='logo-img' alt='logo' src={logo} />

                    <div className='login-title'>כניסת משתמש</div>
                    <form className='login-form' onSubmit={handleUserLogin}>
                        <input
                            className='login-input'
                            type="email"
                            name="Email"
                            placeholder='אימייל'
                            value={user.Email}
                            onChange={handleChange}
                            required
                        />
                        {!isForgotPassword && (
                            <input
                                className='login-input'
                                type="password"
                                name="Password"
                                placeholder='סיסמא'
                                value={user.Password}
                                onChange={handleChange}
                                required
                            />
                        )}
                        {!isForgotPassword && (
                            <LoadingButton
                                className='login-btn'
                                loading={loading}
                                sx={{
                                    backgroundColor: 'transparent', // Remove default background
                                    boxShadow: 'none', // Remove default shadow
                                    '&:hover': {
                                        backgroundColor: 'transparent', // Ensure no hover effect
                                    },
                                    color: '#ffffff', // Customize text color
                                    border: 'none', // Remove border
                                    padding: '10px 30px 10px 30px',
                                    borderRadius: '100px',
                                    // Adjust padding if needed
                                }}
                                type="submit"
                                onClick={() => { setLoading(true); handleUserLogin(); }}
                            >
                                <span className='pagesNavigate-text'>
                                    כניסה
                                </span>
                                <ArrowBackIcon />
                            </LoadingButton>
                        )}
                    </form>
                    <button
                        className='forgot-password-btn'
                        onClick={(e) => {
                            setIsForgotPassword(true);
                            handleForgotPassword(e);
                        }}
                    >
                        שכחתי סיסמא
                    </button>
                </div>
            </div>
        </>
    );
};

export default Login;
